module.exports = __webpack_public_path__ + "static/Apercu-MediumItalic-ee72eaf964263df5859e07d02bf22a29.woff2";